export default "__VITE_ASSET__90568667__"